module.exports = __webpack_public_path__ + "img/select-arrow-error.3252c586.svg";